import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, ButtonGroup, Glyphicon, Panel} from 'react-bootstrap'
import TreatmentForm, {createTreatmentInitialValues} from './TreatmentForm'
import * as Date from "../../utils/date"
import {TreatmentTypeLabel} from "../../utils/enums";
import {Enums} from "../../utils";
import type {ItemTableContext} from "./helpers";
import {formatItemActions, renderItemTable} from "./helpers";

class DogTreatments extends Component {

	tableCtx: ItemTableContext;

	constructor(props) {
		super(props)

		this.state = {
			itemModalOpen: false,
			treatmentId: null,
		}

		this.handleItemModalClick = this.handleItemModalClick.bind(this);
		this.handleItemModalDismiss = this.handleItemModalDismiss.bind(this);

		this.tableCtx = {
			itemKeyName: 'treatmentId',
			cols: [
				{title: 'Datum', width: 17},
				{title: 'Typ', width: 19},
				{title: 'Popis', width: 37},
				{title: 'Provedl', width: 17},
			],
			renderRow: (item, files, props) => {
				const {enums} = props;
				return <tr key={item.treatmentId} title={item.createdBy && Enums.getEnumTitle(enums, 'user', item.createdBy) + ' ' + Date.formatDateTime(item.createdAt)}>
					<td title={item.treatmentId}>
						{item.treatDate && Date.formatDate(item.treatDate)}
						{item.treatFrom && Date.formatDate(item.treatFrom)}
						{item.treatTo && Date.formatDate(item.treatTo)}
					</td>
					<td>{TreatmentTypeLabel[item.treatType]}</td>
					<td>{this.formatDescription(item)}</td>
					<td>{item.treatBy && Enums.getEnumTitle(enums, 'user', item.treatBy)}</td>
					<td>{formatItemActions(item, 'treatmentId', files, this.handleItemModalClick)}</td>
				</tr>
			}
		}
	}

	componentWillMount() {
		this.props.onFetchData(this.props.dogId)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.dogId !== this.props.dogId) {
			this.props.onFetchData(nextProps.dogId)
		}
	}

	handleItemModalClick(treatmentId) {
		this.setState({itemModalOpen: true, treatmentId})
	}

	handleItemModalDismiss() {
		this.setState({itemModalOpen: false, treatmentId: null})
	}

	formatDescription(item) {
		const rows = [];
		if (item.treatTitle || item.treatPeriod) {
			rows.push(<div key={'treatTitle'}>{item.treatTitle} {item.treatPeriod}</div>);
		}
		if (item.treatReason) {
			rows.push(<div key={'treatReason'}>{item.treatReason}</div>)
		}
		return <div title={JSON.stringify(item)}>{rows}</div>;
	}

	renderItemModal() {
		const {dogId, session} = this.props;
		const {itemModalOpen, treatmentId} = this.state;
		if (!itemModalOpen) {
			return null
		}
		return <TreatmentForm treatment={createTreatmentInitialValues(treatmentId, dogId, session)} modal={{
			onHide: this.handleItemModalDismiss,
			onSuccess: (item) => this.props.onFetchData(item.dogId, true)
		}}/>
	}

	render() {
		return <Panel>
			<Panel.Heading>
				<div className={'panel-title'}>
					Pokyny k ošetřování
					<ButtonGroup className="pull-right">
						<Button type="button" className="btn btn-default btn-xs" onClick={() => this.handleItemModalClick(null)}><Glyphicon glyph="plus"/> Přidat</Button>
					</ButtonGroup>
				</div>
			</Panel.Heading>
			<Panel.Body>
				{renderItemTable(this.tableCtx, this.props)}
				{this.renderItemModal()}
			</Panel.Body>
		</Panel>
	}
}

DogTreatments.propTypes = {
	dogId: PropTypes.number.isRequired,
	files: PropTypes.array,
	onFetchData: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
}

export default DogTreatments



// WEBPACK FOOTER //
// ./src/components/dog/DogTreatments.js